
  import React from 'react'
  import { MDXTag } from '@mdx-js/tag'
  

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = null
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             
             components={components}><div className='title'>Contactez-nous!</div>
Vivez-vous en zone de danger ou avez-vous connaissance d’un bâtiment particulièrement exposé? N’hésitez pas à contacter notre rédaction:<a href="mailto:cellule-enquete@tamedia.ch">cellule-enquete@tamedia.ch</a>
           </MDXTag>
  }
}
MDXContent.isMDXComponent = true
  